class MeetTheCrewSlider {
  constructor(sectionContainer) {
    this.container = sectionContainer;
    this.slider = this.container.querySelector('.js-crew-slider');
    this.slides = Array.from(this.container.querySelectorAll('.js-crew-slide'));
    this.dotsContainers = Array.from(this.container.querySelectorAll('.js-dots-container'));

    if (this.slides.length === 0) return;

    this.currentIndex = 0;
    this.init();
  }

  init() {
    this.createDots();
    this.addEventListeners();
    this.goToSlide(0);
  }

  createDots() {
    this.dotsContainers.forEach((container) => {
      container.innerHTML = '';
      this.slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `meet-the-crew__dot${idx === 0 ? ' active' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.dataset.index = idx;
        container.appendChild(dot);
      });
    });
    this.dots = Array.from(this.container.querySelectorAll('.meet-the-crew__dot'));
  }

  addEventListeners() {
    if (this.slider) {
      this.slider.addEventListener('click', (e) => {
        if (e.target.closest('.js-prev-btn')) {
          this.prevSlide();
        }
        if (e.target.closest('.js-next-btn')) {
          this.nextSlide();
        }
        const dot = e.target.closest('.meet-the-crew__dot');
        if (dot) {
          const index = parseInt(dot.dataset.index, 10);
          if (!isNaN(index)) {
            this.goToSlide(index);
          }
        }
      });
    }

    document.addEventListener('shopify:block:select', (e) => {
      if (e.target.closest(`#meet-the-crew-${this.container.dataset.sectionId}`)) {
        const slide = e.target.closest('.js-crew-slide');
        if (slide) {
          const index = parseInt(slide.dataset.slideIndex, 10);
          if (!isNaN(index)) {
            this.goToSlide(index);
          }
        }
      }
    });
  }

  goToSlide(index) {
    if (index < 0) {
      index = this.slides.length - 1;
    } else if (index >= this.slides.length) {
      index = 0;
    }

    this.currentIndex = index;

    this.slides.forEach((slide, idx) => {
      if (idx === this.currentIndex) {
        slide.classList.add('active');
        const bgColor = slide.dataset.bgColor;
        if (bgColor) {
          this.container.style.setProperty('--meet-the-crew-bg', bgColor);
          this.container.style.setProperty('--meet-the-crew-divider-fill-color', bgColor);
          this.container.style.setProperty('--meet-the-crew-divider-bottom-fill-color', bgColor);
        }
        const navActive = slide.dataset.navActive;
        if (navActive) {
          this.container.style.setProperty('--meet-the-crew-btn-bg', navActive);
        }
        const navNormal = slide.dataset.navNormal;
        if (navNormal) {
          this.container.style.setProperty('--meet-the-crew-dot-normal', navNormal);
        }
        const navArrow = slide.dataset.navArrow;
        if (navArrow) {
          this.container.style.setProperty('--meet-the-crew-btn-color', navArrow);
        }
      } else {
        slide.classList.remove('active');
      }
    });

    if (this.dots) {
      this.dots.forEach((dot) => {
        const dotIndex = parseInt(dot.dataset.index, 10);
        if (dotIndex === this.currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }

  nextSlide() {
    this.goToSlide(this.currentIndex + 1);
  }

  prevSlide() {
    this.goToSlide(this.currentIndex - 1);
  }
}

function initCrewSlider(section) {
  new MeetTheCrewSlider(section);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.meet-the-crew').forEach(initCrewSlider);
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.classList.contains('meet-the-crew') ? event.target : event.target.querySelector('.meet-the-crew');
  if (section) {
    initCrewSlider(section);
  }
});
